require(`./src/styles/${process.env.GATSBY_SITE}/global.css`);
